// @ts-nocheck
import {
    OrderDetailsVmiLocationStyles,
    vmiLocationStyles,
} from "@insite/content-library/Widgets/OrderDetails/OrderDetailsVmiLocation";
import { infoProps } from "@store/Themes/common/props/info";

Object.assign<OrderDetailsVmiLocationStyles>(vmiLocationStyles, {
    wrapper: {},
    titleText: infoProps.label,
    vmiLocation: infoProps.value,
});
